import {
    DownloadOutlined,
    UserOutlined,
    MailOutlined,
    PhoneOutlined,
    CalendarOutlined,
    FileTextOutlined,
    TeamOutlined,
} from "@ant-design/icons";
import { Button, Col, Tag, Spin, Card, Row, Select, message, Space, Typography } from "antd";
import { useEffect, useState } from "react";
import { authApis } from "../../../services/authApi";
import MainLayout from "../../../components/mainLayout";
import { useParams, useNavigate } from "react-router-dom";
import moment from 'moment';

const { Title, Text } = Typography;
const { Option } = Select;

const ApplyDetail = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [application, setApplication] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [isUpdatingStatus, setIsUpdatingStatus] = useState(false);

    useEffect(() => {
        fetchApplicationDetail();
    }, [id]);

    const fetchApplicationDetail = () => {
        setIsLoading(true);
        authApis
            .getDetailApply(id)
            .then((data) => {
                console.log(data.application);
                setApplication(data.application);
                setIsLoading(false);
            })
            .catch((error) => {
                message.error("Không thể tải thông tin ứng tuyển");
                setIsLoading(false);
            });
    };

    const handleDownloadCV = () => {
        authApis
            .downloadCV(id)
            .then((blob) => {
                console.log('Download response:', blob);
                console.log('Response type:', typeof blob);
                console.log('Response size:', blob.size);
                
                // Check if response is a blob and has content
                if (blob instanceof Blob && blob.size > 100) {
                    // Create download link
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    
                    // Extract filename from application or use default
                    const filename = application.cv_path ? 
                        application.cv_path.split('/').pop() : 
                        `CV_${application.full_name}.pdf`;
                    
                    link.setAttribute('download', filename);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    window.URL.revokeObjectURL(url);
                    
                    message.success("Tải CV thành công!");
                } else {
                    console.error('Invalid response data:', blob);
                    message.error("File tải về không hợp lệ hoặc bị lỗi");
                }
            })
            .catch((error) => {
                console.error('Download error:', error);
                console.error('Error response:', error.response);
                message.error("Không thể tải file CV");
            });
    };

    const handleStatusUpdate = (newStatus) => {
        setIsUpdatingStatus(true);
        authApis
            .updateApplyStatus(id, { status: newStatus })
            .then((data) => {
                setApplication(data.application);
                setIsUpdatingStatus(false);
                message.success("Cập nhật trạng thái thành công!");
            })
            .catch((error) => {
                message.error("Không thể cập nhật trạng thái");
                setIsUpdatingStatus(false);
            });
    };

    const getStatusColor = (status) => {
        switch (status) {
            case 'pending':
                return 'orange';
            case 'reviewed':
                return 'blue';
            case 'accepted':
                return 'green';
            case 'rejected':
                return 'red';
            default:
                return 'default';
        }
    };

    const getStatusText = (status) => {
        switch (status) {
            case 'pending':
                return 'Chờ xử lý';
            case 'reviewed':
                return 'Đã xem xét';
            case 'accepted':
                return 'Đã chấp nhận';
            case 'rejected':
                return 'Đã từ chối';
            default:
                return status;
        }
    };

    if (isLoading) {
        return (
            <MainLayout
                isShowActionHeader={false}
                title=""
                link="/tuyen-dung/list-apply"
                titleNew="Chi tiết ứng tuyển"
            >
                <div style={{ display: 'flex', justifyContent: 'center', padding: '50px' }}>
                    <Spin size="large" />
                </div>
            </MainLayout>
        );
    }

    if (!application) {
        return (
            <MainLayout
                isShowActionHeader={false}
                title=""
                link="/tuyen-dung/list-apply"
                titleNew="Chi tiết ứng tuyển"
            >
                <div style={{ textAlign: 'center', padding: '50px' }}>
                    <Title level={3}>Không tìm thấy thông tin ứng tuyển</Title>
                    <Button type="primary" onClick={() => navigate('/tuyen-dung/list-apply')}>
                        Quay lại danh sách
                    </Button>
                </div>
            </MainLayout>
        );
    }

    return (
        <MainLayout
            isShowActionHeader={false}
            title=""
            link="/tuyen-dung/list-apply"
            titleNew="Chi tiết ứng tuyển"
        >
            <Row gutter={[16, 16]} style={{ paddingTop: '20px', paddingBottom: '20px' }}>
                <Col span={24}>
                    <Card 
                        title={
                            <Space>
                                <UserOutlined />
                                <span>Thông tin ứng viên</span>
                            </Space>
                        }
                        extra={
                            <Space>
                                <Text strong>Trạng thái:</Text>
                                <Tag color={getStatusColor(application.status)}>
                                    {getStatusText(application.status)}
                                </Tag>
                            </Space>
                        }
                        style={{ borderRadius: '10px' }}
                    >
                        <Row gutter={[16, 16]}>
                            <Col xs={24} md={12}>
                                <Space direction="vertical" size="middle" style={{ width: '100%' }}>
                                    <div>
                                        <UserOutlined style={{ marginRight: 8, color: '#1890ff' }} />
                                        <Text strong>Họ và tên: </Text>
                                        <Text>{application.full_name}</Text>
                                    </div>
                                    
                                    <div>
                                        <CalendarOutlined style={{ marginRight: 8, color: '#1890ff' }} />
                                        <Text strong>Ngày sinh: </Text>
                                        <Text>{moment(application.birth_date).format('DD/MM/YYYY')}</Text>
                                    </div>
                                    
                                    <div>
                                        <PhoneOutlined style={{ marginRight: 8, color: '#1890ff' }} />
                                        <Text strong>Số điện thoại: </Text>
                                        <Text>{application.phone}</Text>
                                    </div>
                                </Space>
                            </Col>
                            
                            <Col xs={24} md={12}>
                                <Space direction="vertical" size="middle" style={{ width: '100%' }}>
                                    <div>
                                        <MailOutlined style={{ marginRight: 8, color: '#1890ff' }} />
                                        <Text strong>Email: </Text>
                                        <Text>{application.email}</Text>
                                    </div>
                                    
                                    <div>
                                        <TeamOutlined style={{ marginRight: 8, color: '#1890ff' }} />
                                        <Text strong>Vị trí ứng tuyển: </Text>
                                        <Text>{application.position}</Text>
                                    </div>
                                    
                                    <div>
                                        <CalendarOutlined style={{ marginRight: 8, color: '#1890ff' }} />
                                        <Text strong>Ngày ứng tuyển: </Text>
                                        <Text>{moment(application.created_at).format('DD/MM/YYYY HH:mm')}</Text>
                                    </div>
                                </Space>
                            </Col>
                        </Row>
                    </Card>
                </Col>

                <Col span={24}>
                    <Card 
                        title={
                            <Space>
                                <FileTextOutlined />
                                <span>Hồ sơ CV</span>
                            </Space>
                        }
                        style={{ borderRadius: '10px' }}
                    >
                        {application.cv_path ? (
                            <Space>
                                <Text>File CV: {application.cv_path.split('/').pop()}</Text>
                                <Button 
                                    type="primary" 
                                    icon={<DownloadOutlined />}
                                    onClick={handleDownloadCV}
                                >
                                    Tải CV
                                </Button>
                            </Space>
                        ) : (
                            <Text type="secondary">Không có file CV</Text>
                        )}
                    </Card>
                </Col>

                <Col span={24}>
                    <Card title="Cập nhật trạng thái" style={{ borderRadius: '10px' }}>
                        <Space>
                            <Text strong>Trạng thái hiện tại:</Text>
                            <Tag color={getStatusColor(application.status)}>
                                {getStatusText(application.status)}
                            </Tag>
                            
                            <Text strong>Cập nhật:</Text>
                            <Select
                                value={application.status}
                                style={{ width: 150 }}
                                onChange={handleStatusUpdate}
                                loading={isUpdatingStatus}
                            >
                                <Option value="pending">Chờ xử lý</Option>
                                <Option value="reviewed">Đã xem xét</Option>
                                <Option value="accepted">Đã chấp nhận</Option>
                                <Option value="rejected">Đã từ chối</Option>
                            </Select>
                        </Space>
                    </Card>
                </Col>

                <Col span={24}>
                    <div style={{ textAlign: 'center' }}>
                        <Button 
                            type="default" 
                            onClick={() => navigate('/tuyen-dung/list-apply')}
                        >
                            Quay lại danh sách
                        </Button>
                    </div>
                </Col>
            </Row>
        </MainLayout>
    );
};

export default ApplyDetail; 